import React from 'react';
import styles from './titles.module.scss';
import classNames from 'classnames';

/**
 * @typedef {{
 *  title?: React.ReactNode,
 *  subtitle?: React.ReactNode,
 *  containerStyle?: string,
 * }} ScreenTitleProps
 */

/** @type {React.NamedExoticComponent<ScreenTitleProps>} */
const ScreenTitle = React.memo(({ title = '', subtitle = null, containerStyle }) => (
  <div className={classNames([styles.screenTitleContainer, containerStyle])}>
    <h1>{title}</h1>
    {subtitle && (
      <div className={styles.screenTitleSubtitleContainer}>
        <p>{subtitle}</p>
      </div>
    )}
  </div>
));

export { ScreenTitle };
